import useUserPermission from "~/hooks/useUserPermission";
import { USE_PROJECTS } from "~/router/permissions";

export const useCanUseProjects = (): boolean => useUserPermission(USE_PROJECTS);
